// extracted by mini-css-extract-plugin
export default {"main":"Teammate_main__uKeKw","photo":"Teammate_photo__Mz0fb","name":"Teammate_name__6T4CS","role":"Teammate_role__PZIRP"};